import { Palette } from './types';

export const initialData: Palette[] = [
  {
    title: 'Website palette',
    id: '5426432',
    colors: [
      {
        hex: "#2C5CAE"
      },
      {
        hex: "#0E0AB1"
      }
    ]
  },
  {
    title: 'New project',
    id: '42336331',
    colors: [
      {
        hex: "#CCCCCC"
      },
      {
        hex: "#262626"
      },
      {
        hex: "#DDDDDD"
      }
    ]
  }
]
